import { Button } from 'components';
import { DialogLoading } from 'components/DialogLoading';
import { DialogEmployeeImportDoc } from 'components/Employee/DialogEmployeeImportDoc';
import { EmployeeDialogForm } from 'components/Employee/EmployeeDialogForm';
import { DashboardTitle } from 'components/Titles';
import { useEmployees } from 'hooks/useEmployees';
import { useDisclose } from 'hooks/utilHooks';
import { FC, useEffect } from 'react';

import AddIcon from '@mui/icons-material/Add';
import {
  Alert,
  AlertTitle,
  CircularProgress,
  Grid,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';

import { EmployeeList } from './EmployeeList';
import { EmployeeSearchBar } from './EmployeeSearchBar';

const LoadingTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff4e5',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    border: '0px',
  },
}));

export const Employee: FC = () => {
  // let { path } = useRouteMatch();
  const {
    employees,
    page,
    setPage,
    maxPage,
    loadingList,
    loadingDialog,
    loadingCreate,
    deleteDialog,
    setListErrors,
    getEmployeesCb,
    selectedEmployees,
  } = useEmployees();

  const { isOpen, onClose, onOpen } = useDisclose();

  const importModal = useDisclose();

  useEffect(() => {
    getEmployeesCb(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DashboardTitle title="GESTÃO DE COLABORADORES" />
      </Grid>

      <Grid container item spacing={2} xs={12} md={12} alignItems="baseline">
        <Grid item xs={10} md={9} alignSelf="flex-start">
          <EmployeeSearchBar />
        </Grid>

        <Grid item xs={2} md={3} mb={1} textAlign="right" alignSelf="flex-end">
          <Button
            size="large"
            disabled={Object.keys(selectedEmployees).length === 0}
            onClick={deleteDialog.onOpen}
            sx={{
              alignSelf: 'flex-start',
              justifyContent: 'flex-start',
              maxHeight: 38,
              minWidth: 230,
              color: '#FFF',
            }}
          >
            Excluir colaborador
          </Button>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <EmployeeList
          loading={loadingList}
          {...employees}
          currentPage={page}
          setPage={setPage}
          maxPage={maxPage}
        />
      </Grid>

      {loadingCreate && !loadingDialog.isOpen && (
        <Grid container item xs={12} justifyContent="flex-end">
          <Grid item my={2}>
            <LoadingTooltip
              title={
                <Alert severity="warning">
                  <AlertTitle>Seu cadastro está sendo processado</AlertTitle>
                  Por favor, aguarde!
                </Alert>
              }
              placement="left"
            >
              <CircularProgress size={35} />
            </LoadingTooltip>
          </Grid>
        </Grid>
      )}

      <Grid
        container
        item
        spacing={2}
        xs={12}
        alignItems="stretch"
        justifyContent="flex-end"
      >
        <Grid item>
          <Button onClick={importModal.onOpen}>Importar</Button>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon />}
            size="medium"
            onClick={onOpen}
            sx={{ color: '#FFFFFF' }}
          >
            Cadastrar
          </Button>
        </Grid>
      </Grid>

      {isOpen && (
        <EmployeeDialogForm
          title="Cadastrar Novo Colaborador"
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
      <DialogEmployeeImportDoc
        title="Envio da planilha para Cadastro"
        isOpen={importModal.isOpen}
        onClose={() => {
          setListErrors([]);
          importModal.onClose();
        }}
      />

      <DialogLoading
        isOpen={loadingDialog.isOpen}
        onClose={loadingDialog.onClose}
      />
    </Grid>
  );
};
